import { CheckInput } from '../../checkInput'
import { useCouponRules } from '../couponRulesContext';
import { AiOutlineQuestionCircle } from 'react-icons/ai'

import { Container } from './style';

export function InputCheckAndLabel() {
    const { 
            couponActive, setCouponActive, 
            couponForOnlinePayment, setCouponForOnlinePayment,
            secretCoupon, setSecretCoupon
    } = useCouponRules()

    return(
        <Container>
            <div className="container">
                <CheckInput 
                    handleClickCheck={setCouponActive}
                    inputValueToChange={couponActive}
                />
                <p>Ativo</p>
            </div>
            

            <div className="container">
                <CheckInput 
                    handleClickCheck={setCouponForOnlinePayment}
                    inputValueToChange={couponForOnlinePayment}
                />
                <p>Somente pagamento online</p>
            </div>

            <div className="container">
                <CheckInput 
                    handleClickCheck={setSecretCoupon}
                    inputValueToChange={secretCoupon}
                />
                <div className="secretCouponExplanation">
                    <AiOutlineQuestionCircle />
                    <p>Cupom secreto</p>
                </div>
            </div>
        </Container>
    )
}
